'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  padding: 0px;\n  cursor: ', ';\n'], ['\n  padding: 0px;\n  cursor: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const SVGEl = props => (<svg {...props} />)
var StyledSVGEl = _styledComponents2.default.svg(_templateObject, function (props) {
  return props.onClick ? 'pointer' : 'unset';
});

var SVG = function SVG(_ref) {
  var color = _ref.color,
      width = _ref.width,
      height = _ref.height,
      viewBox = _ref.viewBox,
      svgPath = _ref.svgPath,
      onClick = _ref.onClick,
      className = _ref.className;
  return _react2.default.createElement(
    StyledSVGEl,
    {
      onClick: onClick,
      className: className,
      width: width + 'px',
      height: height + 'px',
      viewBox: viewBox
    },
    _react2.default.createElement('path', { fill: color, d: svgPath })
  );
};

SVG.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  color: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number,
  viewBox: _propTypes2.default.string.isRequired,
  svgPath: _propTypes2.default.string.isRequired
};

exports.default = SVG;